var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/close/small") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.41421356,6 L11.0018043,9.5875907 C11.1698123,9.75559876 11.2490217,9.88731822 11.291906,10.0288055 C11.3347903,10.1702928 11.3347903,10.3149886 11.291906,10.4564759 C11.2490217,10.5979632 11.1698123,10.7296826 11.0018043,10.8976907 L10.8976907,11.0018043 C10.7296826,11.1698123 10.5979632,11.2490217 10.4564759,11.291906 C10.3149886,11.3347903 10.1702928,11.3347903 10.0288055,11.291906 C9.88731822,11.2490217 9.75559876,11.1698123 9.5875907,11.0018043 L6,7.41421356 L2.4124093,11.0018043 C2.24440124,11.1698123 2.11268178,11.2490217 1.97119451,11.291906 C1.82970725,11.3347903 1.68501138,11.3347903 1.54352411,11.291906 C1.40203685,11.2490217 1.27031739,11.1698123 1.10230932,11.0018043 L0.998195742,10.8976907 C0.830187676,10.7296826 0.750978314,10.5979632 0.708094031,10.4564759 C0.665209748,10.3149886 0.665209748,10.1702928 0.708094031,10.0288055 C0.750978314,9.88731822 0.830187676,9.75559876 0.998195742,9.5875907 L4.58578644,6 L0.998195742,2.4124093 C0.830187676,2.24440124 0.750978314,2.11268178 0.708094031,1.97119451 C0.665209748,1.82970725 0.665209748,1.68501138 0.708094031,1.54352411 C0.750978314,1.40203685 0.830187676,1.27031739 0.998195742,1.10230932 L1.10230932,0.998195742 C1.27031739,0.830187676 1.40203685,0.750978314 1.54352411,0.708094031 C1.68501138,0.665209748 1.82970725,0.665209748 1.97119451,0.708094031 C2.11268178,0.750978314 2.24440124,0.830187676 2.4124093,0.998195742 L6,4.58578644 L9.5875907,0.998195742 C9.75559876,0.830187676 9.88731822,0.750978314 10.0288055,0.708094031 C10.1702928,0.665209748 10.3149886,0.665209748 10.4564759,0.708094031 C10.5979632,0.750978314 10.7296826,0.830187676 10.8976907,0.998195742 L11.0018043,1.10230932 C11.1698123,1.27031739 11.2490217,1.40203685 11.291906,1.54352411 C11.3347903,1.68501138 11.3347903,1.82970725 11.291906,1.97119451 C11.2490217,2.11268178 11.1698123,2.24440124 11.0018043,2.4124093 L7.41421356,6 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/close/small",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(3.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#141414",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#008fd2",
    mask: "url(#mask-2)",
    x: -6,
    y: -6,
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSmall);
export default __webpack_public_path__ + "static/media/close-small.4fca9042f0007c40de2f5df19086e742.svg";
export { ForwardRef as ReactComponent };